<div class="add-admin-container">
  <app-dynamic-form
    [jsonSchema]="formSchema"
    [layout]="'horizontal'"
    [submitLabel]="'Add'"
    [resetLabel]="'Cancel'"
    [showActions]="false"
    (formSubmit)="onFormSubmit($event)">
  </app-dynamic-form>

  <div *ngIf="isSubmitting" class="loading-overlay">
    <div class="spinner"></div>
    <p>Adding admin...</p>
  </div>
</div>
